interface IScrollMetrics {
  scrollWidth: number;
  clientWidth: number;
}

/**
 * Дельта для горизонтального scrollLeft по событию колеса.
 * Возвращает null, когда скроллить не нужно: нет overflow либо нулевая дельта.
 * Вертикальное колесо (deltaY) превращается в горизонтальный скролл; если по модулю
 * больше deltaX (трекпад / горизонтальное колесо) — берём его.
 */
export const resolveWheelDelta = (
  { scrollWidth, clientWidth }: IScrollMetrics,
  deltaX: number,
  deltaY: number,
): number | null => {
  if (scrollWidth <= clientWidth) {
    return null;
  }

  const delta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

  return delta || null;
};

/**
 * Новое значение scrollLeft при drag: тянем контент за указателем
 * (движение указателя вправо уменьшает scrollLeft).
 */
export const dragScrollLeft = (startLeft: number, movementX: number): number => startLeft - movementX;
